// extracted by mini-css-extract-plugin
export default {"container":"exams_container__yRY8r","examsContent":"exams_examsContent__SNHeY"};